import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// import ReactDOM from 'client';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './contexts/AuthContext';
import { LocationProvider } from './contexts/LocationContext';

console.log("LOGCAT TEST: index.js has started running.");

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <LocationProvider>
        {/* The App component and ALL its children can now access both Auth and Location contexts */}
        <App />
      </LocationProvider>
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// npm run build in frontend
// firebase deploy --only hosting in frontend
// firebase functions:log --only api in main iNewsBook

// npm install @capacitor/app
// npx cap sync
// npx cap sync android
// npx cap open android
// https://capacitorjs.com/docs/next/cli/telemetry
// npx cap sync android --loglevel=DEBUG   // To know errors in android

// --legacy-peer-deps

// Geocoding API = AIzaSyANMC2nyUb9egWGq9MCzq927TMyr5plFOA - api4 in google console

// <uses-permission android:name="android.permission.ACCESS_COARSE_LOCATION" />
//     <uses-permission android:name="android.permission.ACCESS_FINE_LOCATION" />
//     <uses-feature android:name="android.hardware.location.gps" />

// Step 1: Run a "Debug" Build on Your Device
// Make sure your phone is connected and recognized by Android Studio.
// In Android Studio, click the green "Run" button (▶️) to install and launch the app on your physical device. The app will open and show the white screen. Leave it running.
// Step 2: Open the Chrome Inspector
// On your desktop computer, open the Google Chrome browser.
// In the address bar, type chrome://inspect and press Enter.
// A new page will open. Click on the "Devices" tab on the left if it's not already selected.
// Step 3: Find and Inspect Your App
// You should see your connected Android device listed.
// Under your device's name, you will see a section for your app, identified by its package name (e.g., com.inewsbook.com). It will show the title of your app and a blue "inspect" link.
// Click the "inspect" link.

// Open Logcat: In Android Studio, at the very bottom of the window, click on the "Logcat" tab.
// Select Your Device and App:
// In the Logcat window, make sure your emulator or physical device is selected in the top-left dropdown.
// In the next dropdown, make sure your app's package name (e.g., com.inewsbook.app) is selected.
// Filter for Errors: In the search bar on the right, you can type E/ to filter for only Error messages, or Capacitor to see logs from your app.
// Run Your App: Launch the app from Android Studio.
// Watch the Logs: As your app tries to load, you will see a stream of messages in Logcat. Look for:
// Network Errors: Messages like net::ERR_CONNECTION_REFUSED or net::ERR_CLEARTEXT_NOT_PERMITTED.
// JavaScript Errors: Any errors that would normally appear in your browser's console will be printed here, often prefixed with Capacitor/Console.
// CSP Errors: Messages that explicitly mention "Content-Security-Policy".
// The error message you find in Logcat will tell us the exact reason for the white screen. For example, net::ERR_CLEARTEXT_NOT_PERMITTED means you are trying to connect to an http address instead of https and need to configure Android to allow it.
// Action Plan
// Start with Reason 1: Modify your capacitor.config.json to set the server hostname. This is the most common cause and the most likely fix. Rebuild, sync, and test.
// If that fails, proceed to Reason 2: Add the Content Security Policy <meta> tag to your public/index.html. Rebuild, sync, and test.
// If both fail, use Reason 3: Open Logcat in Android Studio, run the app, and find the specific error message. That message will give us the final clue needed to solve this.
